/**
 * Firebase config - same project as myYogaTherapy (myyogatherapy-b3cf2).
 * Add mysportscoach.online and localhost to Firebase Auth authorized domains in Firebase Console.
 */
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCyPzDaz8zEd41MkRYNtFBPhjXNiH-LnV4',
  authDomain: 'myyogatherapy-b3cf2.firebaseapp.com',
  projectId: 'myyogatherapy-b3cf2',
  storageBucket: 'myyogatherapy-b3cf2.firebasestorage.app',
  messagingSenderId: '557327954975',
  appId: '1:557327954975:web:2d02949287b760b151912a',
  measurementId: 'G-CMEP5ZTC8X',
};

let app: FirebaseApp;
let auth: Auth;
let db: Firestore;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
} catch (e) {
  console.error('Firebase initialization failed:', e);
  throw e;
}

export { app, auth, db };
